/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
import fileToArrayBuffer from "file-to-array-buffer";
import CustomLoader from "../ui/custom-loader";
import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { actions } from "../../actions";
import { Button } from "../../components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Checkbox } from "../../components/ui/checkbox";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import { Textarea } from "../../components/ui/textarea";
import { useToast } from "../../components/ui/use-toast";
import ipfs from "../../config/ipfs";
import getcontractAddress from "../../contractData/contractAddress/addresses";
import { compressImage } from "../../helper/function";
import { cn } from "../../lib/utils";
import { services } from "../../services";
import { web3 } from "../../web3";
import { sendTransactionHash } from "../../services/transactionApi";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@radix-ui/react-popover"; // or your own popover
import { X } from "lucide-react";

const AssetCreate = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [loading, setLoading] = useState(true);
  const [showTime, setShowTime] = useState(false);
  const [showPercentage, setShowPercentage] = useState(false);
  const [categories, setCategories] = useState([]);
  const [creators, setCreators] = useState([]);
  const [co_creators, setCoCreators] = useState([]);
  const [collections, setCollections] = useState([]);
  const [data, setData] = useState({});
  const [token, setToken] = useState(null);
  const [callAPI, setCallAPI] = useState(false);
  const [nftData, setNFTData] = useState();
  const [buffer, setBuffer] = useState({ original: null, compressed: null });
  const [size, setSize] = useState({ original: 0, compressed: 0 });
  const [web3Data, setWeb3Data] = useState(null);
  const [uploadType, setUploadType] = useState(null);
  const [nftContractInstance, setNftContractInstance] = useState(null);

  const [file, setFile] = useState(null);
  const videoInput = useRef();
  const videoElem = useRef();

  const [propertyImages, setPropertyImages] = useState([]);

  const [assetDetails, setAssetDetails] = useState({
    detials: {
      description: "",
      facilities: [] as string[], // store only amenity ids
      // facilities: [] as { name: string; icon: string }[], // updated type
    },
    financial: {
      totalShare: "",
      totalTokenValue: "",
      totalRentalIncome: "",
      totalAssetAppreciation: "",
      investmentReturn: "",
    },
  });

  // const facilityOptions = [
  //   {
  //     name: 'Swimming Pool',
  //     icon: 'https://blocsysdev.infura-ipfs.io/ipfs/QmNSiiGqGVNFZ8nLqwnZt6Y6nSPdiFrrYYupRWZPtPdUh8',
  //   },
  //   {
  //     name: 'Garden',
  //     icon: 'https://blocsysdev.infura-ipfs.io/ipfs/QmNSiiGqGVNFZ8nLqwnZt6Y6nSPdiFrrYYupRWZPtPdUh8',
  //   },
  // ];

  const [amenities, setAmenities] = useState([]);

  const [startTime, setStartTime] = useState(new Date());
  const [saleEndDate, setSaleEndDate] = useState(new Date());

  const [errors, setErrors] = useState<Record<string, string>>({});
  const [showError, setShowError] = useState(false);

  const handleStartTimeChange = (date) => {
    if (!date) {
      toast({
        description: "Start time is required",
        variant: "destructive",
      });
      return;
    }
    setStartTime(date);

    // Store ISO string in data state
    setData({
      ...data,
      startTime: date.toISOString(),
    });
  };

  const handleEndTimeChange = (date) => {
    if (!date) {
      toast({
        description: "End time is required",
        variant: "destructive",
      });
      return;
    }
    setSaleEndDate(date);

    // Store ISO string in data state
    setData({
      ...data,
      saleEndDate: date.toISOString(),
    });
  };

  // Add this validation function
  const validateDates = (start: Date, end: Date): boolean => {
    if (!start || !end) return false;

    // Convert to UTC timestamps
    const startUTC = Math.floor(start.getTime() / 1000);
    const endUTC = Math.floor(end.getTime() / 1000);

    if (startUTC >= endUTC) {
      toast({
        description: "Start time must be before end time",
        variant: "destructive",
      });
      return false;
    }
    return true;
  };

  const saleState = [
    { name: "AUCTION", value: "AUCTION" },
    { name: "BUY NOW", value: "BUY" },
  ];

  const getUserCollections = async (creator) => {
    const collection = await actions.getUserCollections(creator);
    setCollections(collection.data);
    let co_creators = creators
      .filter((data) => data.id !== creator)
      .map((user) => user);
    setCoCreators(co_creators);
  };

  useEffect(() => {
    async function initializeData() {
      try {
        setLoading(true);

        // First initialize web3
        const web3Data = await services.getWeb3();
        if (!web3Data || !web3Data.accounts || !web3Data.accounts[0]) {
          throw new Error("Please connect your wallet first");
        }
        setWeb3Data(web3Data);

        // Then get contract instance
        const contractInstance = await actions.getPropertyFactoryContract();
        if (!contractInstance) {
          throw new Error("Failed to initialize contract");
        }
        setNftContractInstance(contractInstance);

        // Get other data
        const categories = await actions.getCategories();
        setCategories(categories.data);

        const roles = await actions.getRoles();
        const roleId = roles
          .filter((role) => role.roleName === "CREATOR")
          .map((role) => role.id)[0];
        const creators = await actions.getAllUsersByRoleId(roleId);
        setCreators(creators);
        setCoCreators(creators);

        const amenitiesData = await actions.getAmenities();
        setAmenities(amenitiesData.data);

        setLoading(false);
      } catch (error) {
        toast({
          description: "Failed to initialize: " + error.message,
          variant: "destructive",
        });
        setLoading(false);
      }
    }

    initializeData();
  }, []);

  const propertyMinting = async (propData) => {
    try {
      // Validate dates first
      if (!validateDates(startTime, saleEndDate)) {
        throw new Error("Invalid date range");
      }

      // Validate required fields
      if (!propData?.startTime || !propData?.saleEndDate) {
        throw new Error("Start time and end time are required");
      }

      if (!nftContractInstance || !web3Data?.accounts?.[0]) {
        throw new Error("Contract instance or wallet not initialized");
      }

      // Validate all required fields
      const requiredFields = {
        assetName: "Asset name",
        symbol: "Symbol",
        maxSupply: "Max supply",
        minPurchaseToken: "Min purchase amount",
        maxPurchaseToken: "Max purchase amount",
        assetPrice: "Asset price",
        buyTokenAddress: "Buy token address",
        ownerAddress: "Owner address",
        platformFeeRecepient: "Platform fee recipient",
        platformFeePercentage: "Platform fee percentage",
        minHoldingDuration: "Minimum hold duration",
      };

      for (const [field, label] of Object.entries(requiredFields)) {
        if (!propData[field]) {
          throw new Error(`${label} is required`);
        }
      }

      // Convert timestamps to Unix format (seconds)
      const startTimeUnix = Math.floor(
        new Date(propData.startTime).getTime() / 1000,
      );
      const endTimeUnix = Math.floor(
        new Date(propData.saleEndDate).getTime() / 1000,
      );

      // Validate timestamps
      if (startTimeUnix >= endTimeUnix) {
        throw new Error("Start time must be before end time");
      }

      // Convert numeric values to Wei
      const toWei = (value) => {
        if (!value || isNaN(value)) {
          throw new Error(`Invalid value for Wei conversion: ${value}`);
        }
        return web3.utils.toWei(value.toString(), "ether");
      };

      // Format all parameters according to contract requirements
      const params = [
        propData.assetName, // name
        propData.symbol, // symbol
        toWei(propData.maxSupply), // maxTotalSupply
        startTimeUnix, // startTime
        endTimeUnix, // saleEndDate
        web3.utils.toChecksumAddress(propData.buyTokenAddress), // buyToken
        toWei(propData.minPurchaseToken), // minPurchaseAmount
        toWei(propData.maxPurchaseToken), // maxPurchaseAmount
        toWei(propData.assetPrice), // assetPrice
        web3.utils.toChecksumAddress(propData.ownerAddress), // assetOwner
        web3.utils.toChecksumAddress(propData.platformFeeRecepient), // platformFeeRecipient
        propData.platformFeePercentage, // platformFeePercentage
        propData.minHoldingDuration, // minHoldingDuration
        propData.annualYield,
      ];
      // Call the contract function
      await nftContractInstance.methods
        .createPropertyAsset(...params)
        .send({ from: web3Data.accounts[0] })
        .on("transactionHash", async (hash) => {
          propData["txHash"] = hash;
          try {
            const apiResponse = await sendTransactionHash(hash);
          } catch (apiError) {}
        })
        .on("receipt", (receipt) => {
          onReciept(receipt, propData);
        })
        .on("error", (error) => {
          onTransactionError(error, propData);
        });
    } catch (error) {
      toast({
        description: `Error in asset minting: ${error.message}`,
        variant: "destructive",
      });
      throw error;
    }
  };

  // Helper function to safely convert timestamps
  const convertUnixToISO = (timestamp: number | string): string => {
    try {
      // If timestamp is already in milliseconds, use it directly
      if (typeof timestamp === "number" && timestamp > 1000000000000) {
        return new Date(timestamp).toISOString();
      }
      // If timestamp is in seconds, convert to milliseconds
      if (typeof timestamp === "number" && timestamp < 1000000000000) {
        return new Date(timestamp * 1000).toISOString();
      }
      // If timestamp is a string (ISO format), return it as is
      if (typeof timestamp === "string") {
        return timestamp;
      }
      // If timestamp is invalid, return current date
      return new Date().toISOString();
    } catch (error) {
      return new Date().toISOString();
    }
  };

  const onReciept = async (receipt, currentData) => {
    try {
      // Convert the timestamp safely
      const saleEndIsoDate = convertUnixToISO(currentData?.saleEndDate);

      // Extract the deployed property address from transaction logs
      let deployedPropertyAddress = null;

      if (receipt.logs && receipt.logs.length > 0) {
        // Find the PropertyAssetCreated event
        for (const log of receipt.logs) {
          try {
            // Decode the log to check if it's the PropertyAssetCreated event
            const decodedLog = web3.eth.abi.decodeLog(
              [
                {
                  type: "address",
                  name: "asset",
                  indexed: true,
                },
                {
                  type: "string",
                  name: "name",
                  indexed: false,
                },
                {
                  type: "string",
                  name: "symbol",
                  indexed: false,
                },
                {
                  type: "uint256",
                  name: "maxTotalSupply",
                  indexed: false,
                },
                {
                  type: "uint256",
                  name: "startTime",
                  indexed: false,
                },
                {
                  type: "uint256",
                  name: "saleEndDate",
                  indexed: false,
                },
                {
                  type: "address",
                  name: "buyToken",
                  indexed: false,
                },
                {
                  type: "uint256",
                  name: "minPurchaseAmount",
                  indexed: false,
                },
                {
                  type: "uint256",
                  name: "maxPurchaseAmount",
                  indexed: false,
                },
                {
                  type: "uint256",
                  name: "assetPrice",
                  indexed: false,
                },
                {
                  type: "address",
                  name: "assetOwner",
                  indexed: false,
                },
                {
                  type: "address",
                  name: "platformFeeRecipient",
                  indexed: false,
                },
                {
                  type: "uint256",
                  name: "platformFeePercentage",
                  indexed: false,
                },
                {
                  type: "uint256",
                  name: "minHoldingDuration",
                  indexed: false,
                },
                {
                  type: "uint256",
                  name: "assetYield",
                  indexed: false,
                },
              ],
              log.data,
              [log.topics[1]],
            ); // topics[0] is the event signature, topics[1] is the indexed asset address

            // If we successfully decoded the log, this is our PropertyAssetCreated event
            deployedPropertyAddress = decodedLog.asset;
            break;
          } catch (decodeError) {
            // This log is not the PropertyAssetCreated event, continue to next log
            continue;
          }
        }
      }

      // If we found the deployed property address, call setRental on it
      if (deployedPropertyAddress) {
        try {
          // Add a small delay to ensure the blockchain has processed the property creation
          await new Promise((resolve) => setTimeout(resolve, 2000));

          // Get the property asset contract instance using the existing action
          const propertyContract = await actions.getPropertyAssetContract(
            deployedPropertyAddress,
          );

          if (!propertyContract) {
            throw new Error("Failed to get property asset contract instance");
          }

          // Get the rental pool address
          const rentalPoolAddress = getcontractAddress().rentalPool;

          if (!rentalPoolAddress || !web3.utils.isAddress(rentalPoolAddress)) {
            throw new Error("Invalid rental pool address");
          }

          // Call setRental function on the deployed property contract
          await propertyContract.methods
            .setRental(rentalPoolAddress)
            .send({
              from: web3Data.accounts[0],
            })
            .on("transactionHash", async (hash) => {
              try {
                const apiResponse = await sendTransactionHash(hash);
              } catch (apiError) {}
            })
            .on("receipt", (setRentalReceipt) => {
              toast({
                description: "Property rental address set successfully",
                variant: "default",
              });
            })
            .on("error", (setRentalError) => {
              toast({
                description:
                  "Failed to set rental address: " + setRentalError.message,
                variant: "destructive",
              });
            });
        } catch (setRentalError) {
          toast({
            description:
              "Failed to set rental address: " + setRentalError.message,
            variant: "destructive",
          });
        }
      } else {
        toast({
          description: "Property created but could not set rental address",
          variant: "destructive",
        });
      }

      const updatedData = {
        ...currentData,
        status: "APPROVED",
        saleEndDate: saleEndIsoDate,
        maxSupply: Number(currentData?.maxSupply),
        deployedPropertyAddress: deployedPropertyAddress, // Add the deployed address to the data
      };

      setLoading(false);
      toast({
        description: "Property added successfully",
        variant: "default",
      });
      setData(updatedData);
      await createProperty(updatedData);
      navigate("/assets");
    } catch (error) {
      toast({
        description: "Error processing receipt: " + error.message,
        variant: "destructive",
      });
    }
  };

  const onTransactionError = async (error, currentData) => {
    try {
      // Convert the timestamp safely
      const saleEndIsoDate = convertUnixToISO(currentData?.saleEndDate);

      const updatedData = {
        ...currentData,
        status: "REJECTED",
        saleEndDate: saleEndIsoDate,
        maxSupply: Number(data?.maxSupply),
      };

      setLoading(false);
      await createProperty(updatedData);
      toast({
        description: "Property can not be added successfully",
        variant: "destructive",
      });
    } catch (error) {
      toast({
        description: "Error processing transaction error: " + error.message,
        variant: "destructive",
      });
    }
  };

  // Add this component inside the NFTCreate component
  const PropertyImagesSection = () => (
    <div className="mt-8 mb-8 space-y-6">
      <h4 className="text-2xl font-semibold ">Additional Property Images</h4>

      {propertyImages.length === 0 ? (
        <div className="text-center py-12 bg-secondary rounded-lg border-2 border-dashed">
          <svg
            className="mx-auto h-12 w-12 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <h3 className="mt-2 text-sm font-medium text-gray-900">
            No images added
          </h3>
          <p className="mt-1 text-sm text-gray-500">
            Add property images to showcase more details
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-6">
          {propertyImages.map((img, index) => (
            <Card
              key={index}
              className="relative overflow-hidden bg-white shadow-md hover:shadow-lg transition-shadow duration-200"
            >
              <CardContent className="p-5 bg-gray-500">
                <div className="absolute top-3 right-3 z-10 flex gap-2">
                  <Button
                    variant="destructive"
                    size="sm"
                    className="h-8 w-8 p-0"
                    onClick={() => {
                      const updatedImages = propertyImages.filter(
                        (_, i) => i !== index,
                      );
                      setPropertyImages(updatedImages);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
                    </svg>
                  </Button>
                </div>
                <div className="mb-4">
                  <div className="relative">
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-gray-400 transition-colors duration-200">
                      <Input
                        id={`propertyImage_${index}`}
                        type="file"
                        accept="image/*"
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        onChange={async (e) => {
                          const file = e.target.files?.[0];
                          if (file) {
                            const updatedImages = [...propertyImages];
                            updatedImages[index] = {
                              ...updatedImages[index],
                              file: file,
                            };
                            setPropertyImages(updatedImages);
                          }
                        }}
                      />
                      {!img.file && (
                        <div className="text-gray-500">
                          <svg
                            className="mx-auto h-12 w-12 text-gray-400"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 4v16m8-8H4"
                            />
                          </svg>
                          <span className="mt-2 block text-sm font-medium">
                            Click to upload or drag and drop
                          </span>
                          <span className="mt-1 block text-xs text-gray-500">
                            PNG, JPG, GIF up to 10MB
                          </span>
                        </div>
                      )}
                    </div>
                    {img.file && (
                      <div className="mt-2 relative w-full h-[200px] rounded-lg overflow-hidden bg-gray-100">
                        <img
                          src={URL.createObjectURL(img.file)}
                          alt={`Property image ${index + 1}`}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="space-y-2">
                  <Label
                    htmlFor={`description_${index}`}
                    className="text-sm font-medium text-gray-700"
                  >
                    Image Description
                  </Label>

                  <Textarea
                    source={`description_${index}`}
                    label="Image Description"
                    placeholder="Enter image description"
                    multiline
                    rows={3}
                    fullWidth
                    defaultValue={img.description || ""}
                    onBlur={(e) => {
                      const updatedImages = [...propertyImages];
                      updatedImages[index] = {
                        ...updatedImages[index],
                        description: e.target.value,
                      };
                      setPropertyImages(updatedImages);
                    }}
                    // style={{
                    //     backgroundColor: 'white',
                    //     borderRadius: '8px',
                    // }}
                  />
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}

      {/* New Add Image Button Row */}
      <div className="mt-8 pt-6 border-t border-gray-200">
        <Button
          variant="outline"
          className="w-full h-24 flex flex-col items-center justify-center gap-3 border-2 border-dashed border-gray-300 border-gray-400 transition-all duration-200"
          onClick={() =>
            setPropertyImages([
              ...propertyImages,
              { file: null, description: "" },
            ])
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-gray-600"
          >
            <path d="M12 5v14M5 12h14" />
          </svg>
          <div className="flex flex-col items-center">
            <span className="text-base font-medium text-gray-300">
              Add New Image
            </span>
            <span className="text-sm text-gray-300">
              Upload a property image
            </span>
          </div>
        </Button>
      </div>
    </div>
  );

  const createProperty = async (propertyData) => {
    setLoading(true);
    try {
      // Create FormData instance
      const formData = new FormData();
      let calcTotalTokenValue =
        assetDetails.financial.totalShare * propertyData.assetPrice;
      const minAppreciation = 30;
      const maxAppreciation = 50;
      const randomPercentage =
        Math.floor(Math.random() * (maxAppreciation - minAppreciation + 1)) +
        minAppreciation;
      const calcTotalAssetAppreciation =
        (calcTotalTokenValue * randomPercentage) / 100;

      // Calculate random rental income between 20-39% of total asset value
      const minRental = 20;
      const maxRental = 39;
      const randomRentalPercentage =
        Math.floor(Math.random() * (maxRental - minRental + 1)) + minRental;
      const calcTotalRentalIncome =
        (calcTotalTokenValue * randomRentalPercentage) / 100;

      // Add main image file - backend will handle MinIO upload
      if (data.image && data.image instanceof File) {
        formData.append("mainImage", data.image);
      }

      // Add side images - ensure they are images
      propertyImages.forEach((img) => {
        if (img.file && img.file.type.startsWith("image/")) {
          formData.append("sideImages", img.file);
          formData.append(
            `description_${img.file.name}`,
            img.description || "",
          );
        } else {
          throw new Error(
            `File ${img.file?.name || "unknown"} is not an image file`,
          );
        }
      });

      // Add PDF documents with correct content type
      const pdfMimeType = "application/pdf";
      if (data.assetView?.type === pdfMimeType)
        formData.append("assetOverview", data.assetView);
      if (data.roomsAmenities?.type === pdfMimeType)
        formData.append("roomsAmenities", data.roomsAmenities);
      if (data.assetFloorplans?.type === pdfMimeType)
        formData.append("assetFloorplans", data.assetFloorplans);
      if (data.projectedFigures?.type === pdfMimeType)
        formData.append("projectedFigures", data.projectedFigures);
      if (data.marketOverview?.type === pdfMimeType)
        formData.append("marketOverview", data.marketOverview);
      if (data.RERAapproved?.type === pdfMimeType)
        formData.append("RERAapproved", data.RERAapproved);
      if (data.VARAapproved?.type === pdfMimeType)
        formData.append("VARAapproved", data.VARAapproved);

      // Prepare the main data object
      const mainData = {
        ...propertyData,
        AssetDetials: {
          detials: {
            description:
              assetDetails.detials.description || propertyData.description,
            // facilities:
            //   assetDetails.detials.facilities?.map((facility) => ({
            //     name: facility.name,
            //     icon: facility?.icon || '',
            //   })) || [],
            facilities: assetDetails.detials.facilities, // <-- FIXED
          },
          financial: {
            totalShare: assetDetails.financial.totalShare,
            totalTokenValue: calcTotalTokenValue,
            // totalRentalIncome: assetDetails.financial.totalRentalIncome,
            totalRentalIncome: calcTotalRentalIncome,
            totalAssetAppreciation: calcTotalAssetAppreciation,
            investmentReturn: assetDetails.financial.investmentReturn,
          },
        },
      };

      // Add the JSON data as a string
      formData.append("data", JSON.stringify(mainData));
      // Send multipart form data request
      // const response = await services.post("asset/create", formData, {
      const response = await services.post("asset/create", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status < 200 || response.status >= 300) {
        throw new Error(response.statusText);
      }

      return response;
    } catch (error) {
      notify("Failed to create property: " + error.message, "error");
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const onSuccess = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      const image = data.image;
      let updatedImageData = {};

      // Keep the image File object - backend will handle MinIO upload
      // No need to upload to IPFS anymore
      if (image) {
        updatedImageData = {
          ...data,
          image: image, // Keep the File object
          imageFormat: uploadType,
        };
        setData(updatedImageData);
        setCallAPI(true);
      }

      if (!nftContractInstance || !web3Data?.accounts?.[0]) {
        throw new Error("Contract instance or wallet not initialized");
      }
      await propertyMinting(updatedImageData);
    } catch (error) {
      toast({
        description: "Failed to mint property: " + error.message,
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  const getAddress = (id, creators) => {
    const address = creators
      .filter((data) => data.id === id)
      .map((user) => user.walletAddress)[0];
    return address;
  };

  const validateForm = () => {
    const newErrors: Record<string, string> = {};

    // Validate URLs
    if (!data.locationUrl?.trim()) {
      newErrors.locationUrl = "Location URL is required";
    } else if (!isValidUrl(data.locationUrl)) {
      newErrors.locationUrl = "Please enter a valid URL";
    }

    if (!data.socialYtUrl?.trim()) {
      newErrors.socialYtUrl = "YouTube URL is required";
    } else if (!isValidUrl(data.socialYtUrl)) {
      newErrors.socialYtUrl = "Please enter a valid URL";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const isValidUrl = (url: string) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const [showFacilities, setShowFacilities] = useState(false);

  return (
    <>
      {loading && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <CustomLoader size="lg" className="text-white" />
        </div>
      )}
      <Card className="w-full space-y-6 mx-auto p-6">
        <CardHeader>
          <CardTitle>Create New Asset</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={onSuccess} className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-2">
                <Label htmlFor="fileType">File Type</Label>
                <Select
                  onValueChange={(value) => setUploadType(value)}
                  // defaultValue='image'
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select file type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="image">Image</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-2">
                <Label htmlFor="image">Property Asset Image</Label>
                <Input
                  id="image"
                  type="file"
                  accept="image/*"
                  className="cursor-pointer"
                  onChange={async (e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      let fileType = file.type;
                      if (
                        file.size > 1572864 &&
                        !fileType.search("image") &&
                        !fileType.includes("gif")
                      ) {
                        let compFile = await compressImage(file);
                        let compBuffer = await fileToArrayBuffer(compFile);
                        let originBuffer = await fileToArrayBuffer(file);
                        setBuffer({
                          ...buffer,
                          original: originBuffer,
                          compressed: compBuffer,
                        });
                        setSize({
                          ...size,
                          original: file.size,
                          compressed: compFile.size,
                        });
                      } else {
                        const data = await fileToArrayBuffer(file);
                        setBuffer({
                          ...buffer,
                          original: data,
                          compressed: data,
                        });
                        setSize({
                          ...size,
                          original: file.size,
                          compressed: file.size,
                        });
                      }
                      setData({ ...data, image: file });
                    }
                  }}
                />
              </div>

              {file && (
                <div className="col-span-2">
                  <video
                    className="w-full max-w-[450px] h-auto mx-auto"
                    ref={videoElem}
                    src={file}
                    controls
                  />
                </div>
              )}

              <div className="space-y-2">
                <Label htmlFor="name">Asset Name</Label>
                <Input
                  id="name"
                  required
                  placeholder="E.g., Alex Apartment Complex"
                  onChange={(e) =>
                    setData({
                      ...data,
                      assetName: e.target.value,
                    })
                  }
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="description">Description</Label>
                <Textarea
                  id="description"
                  required
                  placeholder="Enter asset description"
                  value={data.description || ""}
                  onChange={(e) =>
                    setData((prevData) => ({
                      ...prevData,
                      description: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="symbol">Symbol</Label>
                <Input
                  id="symbol"
                  required
                  placeholder="3-5 letters (e.g., LUXAP)"
                  onChange={(e) => setData({ ...data, symbol: e.target.value })}
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="maxSupply">Max Supply</Label>
                <Input
                  id="maxSupply"
                  type="number"
                  required
                  placeholder="Total number of tokens to be created(e.g., 1000)"
                  onChange={(e) => {
                    setData({
                      ...data,
                      maxSupply: e.target.value,
                    });
                    setAssetDetails({
                      ...assetDetails,
                      financial: {
                        ...assetDetails.financial,
                        totalShare: e.target.value,
                      },
                    });
                  }}
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="paymentToken">Payment Token</Label>
                <Select
                  onValueChange={(value) =>
                    setData({ ...data, buyTokenAddress: value })
                  }
                  // defaultValue={getcontractAddress().token}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select payment token" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value={getcontractAddress().token}>
                      USDT
                    </SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-2">
                <Label htmlFor="minPurchaseToken">Min. Purchase Token</Label>
                <Input
                  id="minPurchaseToken"
                  type="number"
                  required
                  placeholder="Minimum tokens per investor (e.g., 100)"
                  onChange={(e) =>
                    setData({
                      ...data,
                      minPurchaseToken: e.target.value,
                    })
                  }
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="maxPurchaseToken">Max. Purchase Token</Label>
                <Input
                  id="maxPurchaseToken"
                  type="number"
                  required
                  placeholder="Maximum tokens per investor (e.g., 10000)"
                  onChange={(e) =>
                    setData({
                      ...data,
                      maxPurchaseToken: e.target.value,
                    })
                  }
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="assetPrice">Price Per Asset Token</Label>
                <Input
                  id="assetPrice"
                  type="number"
                  required
                  placeholder="Price in USDT (e.g., 1.00 = 1 USDT)"
                  onChange={(e) =>
                    setData({
                      ...data,
                      assetPrice: e.target.value,
                    })
                  }
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="ownerAddress">Owner Address</Label>
                <Input
                  id="ownerAddress"
                  required
                  placeholder="Property owner's wallet (0x...)"
                  onChange={(e) =>
                    setData({
                      ...data,
                      ownerAddress: e.target.value,
                    })
                  }
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="platformFeeRecepient">
                  Platform Fee Recipient
                </Label>
                <Input
                  id="platformFeeRecepient"
                  placeholder="Platform fee wallet address (0x...)"
                  required
                  onChange={(e) =>
                    setData({
                      ...data,
                      platformFeeRecepient: e.target.value,
                    })
                  }
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="platformFeePercentage">
                  Platform Fee Percentage
                </Label>
                <Input
                  id="platformFeePercentage"
                  placeholder="Enter fee % (between 0 to 100,e.g, 80)"
                  type="number"
                  required
                  onChange={(e) =>
                    setData({
                      ...data,
                      platformFeePercentage: e.target.value,
                    })
                  }
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="category">Category</Label>
                <Select
                  onValueChange={(value) =>
                    setData({ ...data, assetType: value })
                  }
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select category" />
                  </SelectTrigger>
                  <SelectContent>
                    {categories.map((category) => (
                      <SelectItem key={category._id} value={category._id}>
                        {category.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-2">
                <Label htmlFor="startTime" className="font-medium">
                  Start Date & Time
                </Label>
                <div className="relative w-full">
                  <DatePicker
                    selected={startTime}
                    onChange={handleStartTimeChange}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    dateFormat="MMMM d, yyyy h:mm aa"
                    minDate={new Date()}
                    className="w-full rounded-md border border-input px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer hover:border-primary focus:border-primary transition-colors pr-10 text-black dark:text-white bg-white dark:bg-zinc-900"
                    popperClassName="react-datepicker-right"
                    placeholderText="Select start date and time"
                    popperPlacement="bottom-start"
                    popperModifiers={{
                      offset: {
                        name: "offset",
                        options: {
                          offset: [0, 10],
                        },
                      },
                      preventOverflow: {
                        name: "preventOverflow",
                        options: {
                          boundary: "viewport",
                        },
                      },
                    }}
                    wrapperClassName="w-full"
                  />
                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500 dark:text-gray-400">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect
                        x="3"
                        y="4"
                        width="18"
                        height="18"
                        rx="2"
                        ry="2"
                      ></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                </div>
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  Select when the property sale will begin
                </p>
              </div>

              <div className="space-y-2">
                <Label htmlFor="saleEndDate" className="font-medium">
                  End Date & Time
                </Label>
                <div className="relative w-full">
                  <DatePicker
                    selected={saleEndDate}
                    onChange={handleEndTimeChange}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    dateFormat="MMMM d, yyyy h:mm aa"
                    minDate={new Date()}
                    className="w-full rounded-md border border-input px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer hover:border-primary focus:border-primary transition-colors pr-10 text-black dark:text-white bg-white dark:bg-zinc-900"
                    popperClassName="react-datepicker-right"
                    placeholderText="Select end date and time"
                    popperPlacement="bottom-start"
                    popperModifiers={{
                      offset: {
                        name: "offset",
                        options: {
                          offset: [0, 10],
                        },
                      },
                      preventOverflow: {
                        name: "preventOverflow",
                        options: {
                          boundary: "viewport",
                        },
                      },
                    }}
                    wrapperClassName="w-full"
                  />
                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500 dark:text-gray-400">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect
                        x="3"
                        y="4"
                        width="18"
                        height="18"
                        rx="2"
                        ry="2"
                      ></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                </div>
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  Select when the property sale will end
                </p>
              </div>

              <div className="space-y-2">
                <Label htmlFor="countryCode">Country Code</Label>
                <Input
                  id="countryCode"
                  placeholder="2-letter code (e.g., US, GB, SG)"
                  required
                  onChange={(e) =>
                    setData({
                      ...data,
                      countryCode: e.target.value,
                    })
                  }
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="city">City</Label>
                <Input
                  id="city"
                  required
                  placeholder="City name (e.g., New York)"
                  onChange={(e) => setData({ ...data, city: e.target.value })}
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="annualYield">Asset Yield</Label>
                <Input
                  id="annualYield"
                  type="number"
                  required
                  placeholder="Expected yield % (between 0 to 100, e.g., 50)"
                  onChange={(e) =>
                    setData({
                      ...data,
                      annualYield: e.target.value,
                    })
                  }
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="minHoldingDuration">
                  Minimum Holding Duration
                </Label>
                <Input
                  id="minHoldingDuration"
                  type="number"
                  placeholder="Minimum Holding Period (in Seconds)"
                  required
                  onChange={(e) =>
                    setData({
                      ...data,
                      minHoldingDuration: e.target.value,
                    })
                  }
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="locationUrl">Location URL</Label>
                <Input
                  required
                  id="locationUrl"
                  type="url"
                  placeholder="https://maps.google.com/..."
                  onChange={(e) => {
                    setData({
                      ...data,
                      locationUrl: e.target.value,
                    });
                    if (errors.locationUrl) {
                      setErrors({ ...errors, locationUrl: "" });
                    }
                  }}
                  className={cn(errors.locationUrl && "border-red-500")}
                />
                {showError && errors.locationUrl && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.locationUrl}
                  </p>
                )}
              </div>

              <div className="space-y-2">
                <Label htmlFor="socialYtUrl">YouTube URL</Label>
                <Input
                  required
                  id="socialYtUrl"
                  type="url"
                  placeholder="https://youtube.com/..."
                  onChange={(e) => {
                    setData({
                      ...data,
                      socialYtUrl: e.target.value,
                    });
                    if (errors.socialYtUrl) {
                      setErrors({ ...errors, socialYtUrl: "" });
                    }
                  }}
                  className={cn(errors.socialYtUrl && "border-red-500")}
                />
                {showError && errors.socialYtUrl && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.socialYtUrl}
                  </p>
                )}
              </div>

              <div className="col-span-2 space-y-2">
                <Label>Facilities</Label>
                <div className="relative">
                  <Button
                    type="button"
                    variant="outline"
                    className="w-full flex justify-between items-center"
                    onClick={() => setShowFacilities(!showFacilities)}
                  >
                    <span>
                      {assetDetails.detials.facilities.length > 0
                        ? `${assetDetails.detials.facilities.length} facilities selected`
                        : "Select facilities"}
                    </span>
                    <span
                      className={`ml-2 transition-transform duration-200 ${showFacilities ? "rotate-180" : ""}`}
                    >
                      ▼
                    </span>
                  </Button>

                  {showFacilities && (
                    <div className="absolute z-50 w-full mt-1 bg-[#FFFFFF] border border-[#22c55e] rounded-md shadow-lg">
                      <div className="p-2 max-h-[300px] overflow-y-auto">
                        {amenities.map((facility) => {
                          const isSelected =
                            assetDetails.detials.facilities.includes(
                              facility._id,
                            );
                          return (
                            <div
                              key={facility._id}
                              className="flex items-center gap-3 p-2 rounded cursor-pointer"
                            >
                              <Checkbox
                                checked={isSelected}
                                className="rounded-sm"
                                onCheckedChange={(checked) => {
                                  const updatedFacilities = checked
                                    ? [
                                        ...assetDetails.detials.facilities,
                                        facility._id,
                                      ]
                                    : assetDetails.detials.facilities.filter(
                                        (id) => id !== facility._id,
                                      );

                                  setAssetDetails({
                                    ...assetDetails,
                                    detials: {
                                      ...assetDetails.detials,
                                      facilities: updatedFacilities,
                                    },
                                  });
                                }}
                                id={`facility-${facility._id}`}
                              />
                              <label
                                htmlFor={`facility-${facility._id}`}
                                className="flex items-center gap-3 flex-1 cursor-pointer"
                              >
                                {facility.icon && (
                                  <img
                                    src={facility.icon}
                                    alt={facility.name}
                                    className="w-5 h-5 rounded"
                                  />
                                )}
                                <span className="flex-1">{facility.name}</span>
                              </label>
                            </div>
                          );
                        })}
                      </div>
                      <div className="p-2 border-t">
                        <Button
                          type="button"
                          className="w-full bg-[#22c55e] hover:bg-[#bbe245]/90 text-black"
                          onClick={() => setShowFacilities(false)}
                        >
                          Done
                        </Button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Selected Facilities Display */}
                <div className="flex flex-wrap gap-2 mt-3">
                  {assetDetails.detials.facilities.map((id) => {
                    const facility = amenities.find((a) => a._id === id);
                    if (!facility) return null;
                    return (
                      <div
                        key={facility._id}
                        className="flex items-center text-white rounded-md shadow px-2 py-1 gap-2 text-sm mt-2"
                        style={{
                          border: "1px solid #bbe245",
                          backgroundColor: "#074a3f",
                        }}
                      >
                        {facility.icon && (
                          <img
                            src={facility.icon}
                            alt={facility.name}
                            className="w-5 h-5 rounded"
                          />
                        )}
                        <span className="font-medium">{facility.name}</span>
                        <button
                          type="button"
                          className="ml-1 text-gray-400 hover:text-red-400"
                          onClick={() => {
                            setAssetDetails({
                              ...assetDetails,
                              detials: {
                                ...assetDetails.detials,
                                facilities:
                                  assetDetails.detials.facilities.filter(
                                    (fid) => fid !== facility._id,
                                  ),
                              },
                            });
                          }}
                        >
                          <X size={14} />
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Financial Fields - wrap these in a parent div to fix JSX structure */}
              <div className="col-span-2 grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="space-y-2">
                  <Label htmlFor="totalRentalIncome">Total Rental Income</Label>
                  <Input
                    id="totalRentalIncome"
                    type="number"
                    required
                    placeholder="Expected annual rental income in USDT (e.g, 1000)"
                    onChange={(e) => {
                      setAssetDetails({
                        ...assetDetails,
                        financial: {
                          ...assetDetails.financial,
                          totalRentalIncome: e.target.value,
                        },
                      });
                    }}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="totalAssetAppreciation">
                    Total Asset Appreciation
                  </Label>
                  <Input
                    id="totalAssetAppreciation"
                    type="number"
                    required
                    placeholder="Expected value increase in USDT (e.g., 50000)"
                    onChange={(e) => {
                      setAssetDetails({
                        ...assetDetails,
                        financial: {
                          ...assetDetails.financial,
                          totalAssetAppreciation: e.target.value,
                        },
                      });
                    }}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="investmentReturn">Investment Return</Label>
                  <Input
                    id="investmentReturn"
                    type="number"
                    required
                    placeholder="Enter Investment Return %(between 0 to 100,e.g., 20)"
                    onChange={(e) => {
                      setAssetDetails({
                        ...assetDetails,
                        financial: {
                          ...assetDetails.financial,
                          investmentReturn: e.target.value,
                        },
                      });
                    }}
                  />
                </div>
              </div>

              <div className="col-span-2 space-y-6">
                <PropertyImagesSection />
                <h4 className="text-lg font-semibold">Asset Documents</h4>
                <div className="space-y-4">
                  <div className="space-y-2">
                    <Label htmlFor="assetView">Asset View Document</Label>
                    <Input
                      id="assetView"
                      type="file"
                      accept="application/pdf"
                      className="cursor-pointer"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file)
                          setData({
                            ...data,
                            assetView: file,
                          });
                      }}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="roomsAmenities">
                      Rooms & Amenities Document
                    </Label>
                    <Input
                      id="roomsAmenities"
                      className="cursor-pointer"
                      type="file"
                      accept="application/pdf"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file)
                          setData({
                            ...data,
                            roomsAmenities: file,
                          });
                      }}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="assetFloorplans">Asset Floorplans</Label>
                    <Input
                      id="assetFloorplans"
                      type="file"
                      className="cursor-pointer"
                      accept="application/pdf"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file)
                          setData({
                            ...data,
                            assetFloorplans: file,
                          });
                      }}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="projectedFigures">Projected Figures</Label>
                    <Input
                      id="projectedFigures"
                      type="file"
                      className="cursor-pointer"
                      accept="application/pdf"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file)
                          setData({
                            ...data,
                            projectedFigures: file,
                          });
                      }}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="marketOverview">Market Overview</Label>
                    <Input
                      id="marketOverview"
                      type="file"
                      className="cursor-pointer"
                      accept="application/pdf"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file)
                          setData({
                            ...data,
                            marketOverview: file,
                          });
                      }}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="RERAapproved">RERA Approved Document</Label>
                    <Input
                      id="RERAapproved"
                      type="file"
                      className="cursor-pointer"
                      accept="application/pdf"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file)
                          setData({
                            ...data,
                            RERAapproved: file,
                          });
                      }}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="VARAapproved">VARA Approved Document</Label>
                    <Input
                      id="VARAapproved"
                      type="file"
                      className="cursor-pointer"
                      accept="application/pdf"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file)
                          setData({
                            ...data,
                            VARAapproved: file,
                          });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-4">
              <Button
                type="button"
                variant="outline"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="bg-gradientButton hover:bg-primary/90 text-white dark:bg-primary/80 dark:hover:bg-primary/70 dark:text-black/90 transition-colors duration-200 font-medium shadow-sm hover:shadow-md"
              >
                Create Asset
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </>
  );
};

export default AssetCreate;
